import { useRouteSearchParams } from '../routing/params.hook';

const DEFAULT_OFFSET = 1;
const DEFAULT_LIMIT = 24;
const OFFSET_PARAM = 'p';
const LIMIT_PARAM = 'r';

export const usePagedSearchParams = () => {
	const [queryParams, setQueryParams] = useRouteSearchParams();
	const offset = Number(queryParams.get(OFFSET_PARAM)) || DEFAULT_OFFSET;
	const limit = Number(queryParams.get(LIMIT_PARAM)) || DEFAULT_LIMIT;

	return {
		offset,
		limit,
		update: (newOffset: number, newLimit: number) => {
			if (newOffset > 0) {
				queryParams.set(OFFSET_PARAM, newOffset.toString());
			}
			if (newLimit !== DEFAULT_LIMIT) {
				queryParams.set(LIMIT_PARAM, newLimit.toString());
			}
			setQueryParams(queryParams);
		}
	};
};
